<template>
    <div class="global-tab" v-if="isVisible">
        <slot />
    </div>
</template>

<script>
export default {
    name: "global-tab",
    props: {
        header: String
    },
    data() {
        return {
            tabIndex: -1
        }
    },
    inject: ['tabData'],
    computed: {
        isVisible() {
            return this.tabIndex >= 0 && this.tabData.currentTabIndex === this.tabIndex;
        }
    },
    mounted() {
        this.tabIndex = this.tabData.tabs.length;
        this.tabData.tabs.push({
            header: this.header,
            isVisible: this.tabIndex === 0
        });
    },
    beforeDestroy() {
        // TODO... remove from this.tabData.tabs
    },
    destroyed() {
        this.tabIndex = -1;
    }
}
</script>
